import * as List from './list';

const Actions = {
  ...List,
};

export default Actions;
